import { Apple, Laptop, Monitor, type LucideIcon } from "lucide-react";
import type { BuildId, DownloadLinks } from "@/lib/platform";

export function hrefForBuild(id: BuildId, links: DownloadLinks): string {
  switch (id) {
    case "win-x64":
      return links.windowsX64;
    case "win-arm64":
      return links.windowsArm64;
    case "mac-silicon":
      return links.macArm;
    case "mac-intel":
      return links.macIntel;
  }
}

export function labelForBuild(id: BuildId): string {
  switch (id) {
    case "win-x64":
      return "Windows (x64)";
    case "win-arm64":
      return "Windows (ARM64)";
    case "mac-silicon":
      return "macOS (Silicon)";
    case "mac-intel":
      return "macOS (Intel)";
  }
}

export function iconForBuild(id: BuildId): LucideIcon {
  switch (id) {
    case "mac-silicon":
      return Apple;
    case "mac-intel":
      return Laptop;
    default:
      return Monitor;
  }
}
